import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';

// Material UI
import { Button, withStyles } from '@material-ui/core';
import { getGlobalClasses } from '../../../themes';
// import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AuthUserContainer from '../../../containers/AuthUser';
import PtoRequestContainer from '../../../containers/PtoRequest';
import PropTypes from 'prop-types';
import EnhancedTable from '../../../components/table/EnhancedTable';
import FilterHeader from '../../../components/table/FilterHeader';
//import UserCancelPtoRequest from '../../../components/dialogs/UserCancelPtoRequest';

import { renderStatus, statuses, ptoTypeToDisplay, formatPtoRequestHours } from '../util';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class PTORequestDashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'displayName',
			filter: '',
			filterTimeClockLocationId: '',
			refreshId: 0,
			isCancelDialogOpen: false,
			ptoRequestIdToCancel: undefined,
			formattedPtoRequests: undefined,
			formattedPastRequests: undefined,
		};
	}

	handleOpenCancelDialog = (ptoRequestIdToCancel) => {
		this.setState({
			isCancelDialogOpen: true,
			ptoRequestIdToCancel,
		});
	};
	handleCloseCancelDialog = () => {
		this.setState({
			isCancelDialogOpen: false,
			ptoRequestIdToCancel: undefined,
		});
	};
	afterCancelPtoRequest = () => {
		console.log('LETS REDIRECT');
	};

	componentDidMount() {
		const { myPtoRequests, searchPtoRequests } = this.props;
		if (!myPtoRequests) {
			searchPtoRequests({
				params: {
					searchFor: 'myRequests',
				},
			});
		} else {
			this.formatPtoRequests();
		}
	}

	componentDidUpdate(prevProps) {
		const { myPtoRequests } = this.props;
		if (prevProps.myPtoRequests !== myPtoRequests) {
			this.formatPtoRequests();
		}
	}

	formatPtoRequests = () => {
		const { classes } = this.props;
		const { myPtoRequests, userMap } = this.props;
		const formattedPtoRequests = [];
		const formattedPastRequests = [];
		const now = moment().startOf('day');
		myPtoRequests.forEach((ptoRequest) => {
			const {
				paidType,
				ptoRequestId,
				status,
				assignedToHrUserId,
				assignedToSupervisorUserId,
			} = ptoRequest;

			const { totalHours, totalDays, rangeDisplay, rangeSort, lastDay } = formatPtoRequestHours(
				ptoRequest
			);

			const supervisor = userMap[assignedToSupervisorUserId] || { firstName: 'Not assigned yet.' };
			const hr = userMap[assignedToHrUserId] || { firstName: 'Not assigned yet.' };

			const row = {
				ptoRequestId,
				key: ptoRequestId,
				rangeDisplay,
				rangeSort,
				typeDisplay: ptoTypeToDisplay(paidType),
				totalDaysSort: totalDays,
				totalDaysDisplay: totalDays ? `${totalDays}` : '-',
				totalHoursSort: totalHours,
				totalHoursDisplay: `${totalHours} hours`,
				status: renderStatus(status),
				assigned: (
					<>
						<div>
							Supervisor: {supervisor.firstName} {supervisor.lastName}
						</div>
						<div>
							HR: {hr.firstName} {hr.lastName}
						</div>
					</>
				),
				note: '',
				viewCancelButton: (
					<>
						<Button
							variant="outlined"
							className={classes.button}
							color="primary"
							style={{ marginRight: 5 }}
							onClick={() => {
								this.props.history.push(`/pto/request/view/${ptoRequestId}`);
							}}
						>
							View
						</Button>

						{/*
						<Button
							variant="outlined"
							className={classes.button}
							color="secondary"
							onClick={() => {
								this.handleOpenCancelDialog(ptoRequestId);
							}}
						>
							Cancel
						</Button>
						*/}
					</>
				),
				viewButton: (
					<>
						<Button
							variant="outlined"
							className={classes.button}
							color="primary"
							style={{ marginRight: 5 }}
							onClick={() => {
								this.props.history.push(`/pto/request/view/${ptoRequestId}`);
							}}
						>
							View
						</Button>
					</>
				),
			};

			if (
				lastDay.isBefore(now) ||
				_.includes(
					[
						statuses.supervisorCancelled,
						statuses.supervisorDenied,
						statuses.hrDenied,
						statuses.userCancelled,
						statuses.hrCancelled,
					],
					status
				)
			) {
				formattedPastRequests.push(row);
			} else {
				formattedPtoRequests.push(row);
			}
		});
		this.setState({ formattedPastRequests, formattedPtoRequests });
	};

	render() {
		const { classes } = this.props;

		const { formattedPtoRequests, formattedPastRequests } = this.state;

		if (!formattedPtoRequests && !formattedPastRequests) {
			console.log(this.state);
			return <div>Loading the PTO requests</div>;
		}

		const columns = [
			{ label: 'Type', sortId: 'typeDisplay', displayId: 'typeDisplay' },
			{ label: 'First / Last Date', sortId: 'rangeSort', displayId: 'rangeDisplay' },
			{ label: 'Days', sortId: 'totalDaysSort', displayId: 'totalDaysDisplay' },
			{
				label: 'Total Hours',
				sortId: 'totalHoursSort',
				displayId: 'totalHoursDisplay',
			},
			{ label: 'Status', sortId: 'status', displayId: 'status' },
			{ label: 'Assigned', sortId: 'assigned', isNotSortable: true, displayId: 'assigned' },
			{ label: 'View', sortId: 'fix', isNotSortable: true, displayId: 'viewButton' },
		];

		const completedColumns = [
			{ label: 'Type', sortId: 'typeDisplay', displayId: 'typeDisplay' },
			{ label: 'First / Last Date', sortId: 'rangeSort', displayId: 'rangeDisplay' },
			{ label: 'Days', sortId: 'totalDaysSort', displayId: 'totalDaysDisplay' },
			{
				label: 'Total Hours',
				sortId: 'totalHoursSort',
				displayId: 'totalHoursDisplay',
			},
			{ label: 'Status', sortId: 'status', displayId: 'status' },
			{ label: 'Assigned', sortId: 'assigned', isNotSortable: true, displayId: 'assigned' },
			{ label: 'View', sortId: 'fix', isNotSortable: true, displayId: 'viewButton' },
		];

		return (
			<Fragment>
				<FilterHeader
					label={'Upcoming PTO Requests'}
					buttonText="New PTO Request"
					url="/pto/request/add"
					canMakeUpdates={true}
				/>

				<Paper className={classes.globalMainPaper}>
					{_.isEmpty(formattedPtoRequests) && (
						<div style={{ padding: 20, fontSize: 18, color: '#666', paddingBottom: 10 }}>
							You do not have any upcoming PTO Requests. Click the New PTO Request button to start a
							new PTO Request.
						</div>
					)}
					{!_.isEmpty(formattedPtoRequests) && (
						<EnhancedTable
							rows={formattedPtoRequests}
							columns={columns}
							isDense={false}
							defaultOrder={'desc'}
							defaultOrderBy={'durationInSeconds'}
							refreshId={this.state.refreshId}
						/>
					)}
				</Paper>

				<FilterHeader label={'Completed PTO Requests'} canMakeUpdates={true} />

				<Paper className={classes.globalMainPaper}>
					{_.isEmpty(formattedPastRequests) && (
						<div style={{ padding: 20, fontSize: 18, color: '#666', paddingBottom: 10 }}>
							You do not have any Past PTO Requests
						</div>
					)}
					{!_.isEmpty(formattedPastRequests) && (
						<EnhancedTable
							rows={formattedPastRequests}
							columns={completedColumns}
							isDense={true}
							defaultOrder={'desc'}
							defaultOrderBy={'durationInSeconds'}
							refreshId={this.state.refreshId}
						/>
					)}
				</Paper>

				{/*
				<UserCancelPtoRequest
					open={this.state.isCancelDialogOpen}
					onClose={this.handleCloseCancelDialog}
					afterSave={this.afterCancelPtoRequest}
					updatePtoRequest={this.props.updatePtoRequest}
					ptoRequestId={this.state.ptoRequestIdToCancel}
				/>
					*/}
			</Fragment>
		);
	}
}

PTORequestDashboard.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	searchPtoRequests: PropTypes.func.isRequired,
	myPtoRequests: PropTypes.array,
	updatePtoRequest: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	PtoRequestContainer,
])(PTORequestDashboard);
